export const YES_NO_OPTIONS = [
  { id: 'Yes', label: 'Yes', value: 'Yes' },
  { id: 'No', label: 'No', value: 'No' },
];

export default YES_NO_OPTIONS;


